/**
 * What a customer is told when the beta gate refuses them (PRE-3294).
 *
 * `CfBetaEntryGuard` answers 403 on both entry endpoints — the probe and the
 * token connect — so either screen can meet it. The statement of fact lives
 * here so the two cannot drift apart on it; the sentence that follows it does
 * not, because the way out differs by screen.
 */
export const BETA_CLOSED_TITLE = "The automated Cloudflare setup isn't available";

export const BETA_CLOSED_REASON =
  "This setup is in a limited beta and isn't open for your account right now.";
